import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { AppConfig } from "../../../config/app.config";
import { APP_CONFIG } from "../../../config/config.token";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class JobsService {
    constructor(private httpClient: HttpClient,
                @Inject(APP_CONFIG) private config: AppConfig)
    { }

    createJob = (formData: FormData): Observable<string> => {
        return this.httpClient.post<string>(`${this.config.apiUrl}Jobs/create`, formData, { withCredentials: true });
    }

    getJobStatus = (jobid: string): Observable<boolean> => {
        return this.httpClient.get<boolean>(`${this.config.apiUrl}Jobs/Status/${jobid}`, { withCredentials: true });
    }

    getJobs = (): Observable<Array<any>> => {
        return this.httpClient.get<Array<any>>(`${this.config.apiUrl}Jobs/list`, { withCredentials: true });
    }

    completeLiveJob = (formData: FormData): Observable<string> => {
        return this.httpClient.post<string>(`${this.config.apiUrl}Jobs/completed-live`, formData, { withCredentials: true });
    }
}